import { GrinNotificationTypes } from '@grin-rnd/grin-api-sdk/dist/Enums/Notifications'
import BaseGrinNotification from './BaseGrinNotification/BaseGrinNotification'
import { logError } from 'utils/logUtils'
import NewMessageNotification from './NewMessageNotification'
import NewScanNotification from './NewScanNotification'
import PatientAssignedNotification from './PatientAssignedNotification'
import PatientJoinedNotification from './PatientJoinedNotification'
import NewRcLeadNotification from './NewRcLeadNotification'
import NewRecordsAppLeadNotification from './NewRecordsAppLeadNotification'
import NeedsAttentionNotification from './NeedsAttentionNotification'
import UrgentScanNotification from './UrgentScanNotification'
import MessageReaction from './MessageReaction'

const notificationComponentByType = {
  [GrinNotificationTypes.NewMessage]: NewMessageNotification,
  [GrinNotificationTypes.MessageReaction]: MessageReaction,
  [GrinNotificationTypes.NewScan]: NewScanNotification,
  [GrinNotificationTypes.PatientAssigned]: PatientAssignedNotification,
  [GrinNotificationTypes.PatientJoined]: PatientJoinedNotification,
  [GrinNotificationTypes.NewRecordsAppLead]: NewRecordsAppLeadNotification,
  [GrinNotificationTypes.NewRcLead]: NewRcLeadNotification,
  [GrinNotificationTypes.NeedsAttention]: NeedsAttentionNotification,
  [GrinNotificationTypes.UrgentScan]: UrgentScanNotification
}

const factory = notificationType => {
  const notificationComponent = notificationComponentByType[notificationType]
  if (!notificationComponent) {
    logError(`Notification center - missing notification component for type: ${notificationType}`)
    return BaseGrinNotification
  }

  return notificationComponent
}

export default factory
